import { render } from "./Morosi.vue?vue&type=template&id=298584d4&scoped=true"
import script from "./Morosi.vue?vue&type=script&lang=js"
export * from "./Morosi.vue?vue&type=script&lang=js"

import "./Morosi.vue?vue&type=style&index=0&id=298584d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298584d4"]])

export default __exports__